import * as Yup from 'yup';

const password = Yup.string()
  .required('Password is required')
  .min(8, 'Password length must be more than 8 characters')
  // .matches(
  //   /^.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?].*$/,
  //   'Need one special character',
  // )
  .matches(/^.*[A-Z].*$/, 'Need one capital letter');

const confirmPassword = Yup.string()
  .oneOf([Yup.ref('password'), null], 'Passwords must match')
  .required('Password confirm is required');

export default {
  password,
  confirmPassword,
};
